

const storeMonthReport = {
    path: 'storeReportCenter',
    name: 'storeReportCenter',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'reportCenter',
        icon: 'HSIconfont hs-icon-a-reportcenter',
        showRealm: ['NORMAL'],
    },
    children: [
        {
            path: 'storeCommunicationReport',
            name: 'storeCommunicationReport',
            component: () => import('@/views/storeCommunicationReport'),
            meta: { code: "reportCenter:timeoutEsl" },
        },
        {
            path: 'storeFailedEslReport',
            name: 'storeFailedEslReport',
            component: () => import('@/views/storeFailedEslReport'),
            meta: { code: "reportCenter:notOkEsl" },
        },
        {
            path: 'storeMonthReportStatistics',
            name: 'storeMonthReportStatistics',
            component: () => import('@/views/storeMonthReportStatistics'),
            meta: { code: "reportCenter:monthReport" },
        },
        {
            path: 'storeAbnormalApReport',
            name: 'storeAbnormalApReport',
            component: () => import('@/views/storeAbnormalApReport'),
            meta: { code: "reportCenter:abnormalAp" },
        },
    ]
};
export default storeMonthReport;
